<template>
  <v-card elevation="0" color="primary" class="mx-0 mr-0">
    <Header class="px-16 py-6" />
    <v-row class="ma-4">
      <v-col :cols="col1">
        <AboutMe />
        <WorkExperience class="mt-6" />
      </v-col>
      <v-col :cols="col2">
        <Contact />
        <Skills class="mt-8" />
        <Projects class="mt-8" />
        <!-- <Blogs class="mt-8" /> -->
        <Certifications class="mt-8" />
        <VolunteerExperience class="mt-6" />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import store from '../store'

import Header from '../components/Header'
import AboutMe from '../components/Home/AboutMe'
import Contact from '../components/Home/Contact'
import Skills from '../components/Home/Skills'
import WorkExperience from '../components/Home/WorkExperience'
import VolunteerExperience from '../components/Home/VolunteerExperience'
import Projects from '../components/Home/Projects'
import Certifications from '../components/Home/Certifications'
import Blogs from '../components/Blogs'

export default {
  name: 'Home',
  components: {
    Header,
    AboutMe,
    Contact,
    Skills,
    WorkExperience,
    VolunteerExperience,
    Projects,
    Certifications,
    Blogs,
  },
  computed: {
    col1 () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 12
        case 'sm': return 12
        case 'md': return 7
        case 'lg': return 7
        case 'xl': return 7
      }
    },
    col2 () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 12
        case 'sm': return 12
        case 'md': return 5
        case 'lg': return 5
        case 'xl': return 5
      }
    },
  }
}
</script>
